import React from "react";

const Pagenotfound = () => {

    return (
        
        <>
            Pagenotfound
        </>

    );

};

export default Pagenotfound;